import IndividualSignup from './IndividualSignup'
import CompanySignup from './CompanySignup'
import HufSignup from './HufSignup'
import { useLocation } from 'react-router-dom'
import { USERTYPE_ID } from '../../constants/constants'
import './Signup.scss'

const Signup = () => {
  const location = useLocation()
  const { signupType } = location.state;

  const renderSignupComponent = () => {
    switch (signupType) {
      case USERTYPE_ID.INDIVIDUAL:
        return <IndividualSignup signupType={signupType} />;
      case USERTYPE_ID.ENTITY:
        return <CompanySignup signupType={signupType} />;
      case USERTYPE_ID.HUF:
        return <HufSignup signupType={signupType} />;
      case USERTYPE_ID.NBFC:
        return <CompanySignup signupType={signupType} />;
      default:
        return <IndividualSignup signupType={signupType} />;
    }
  };

  return (
    <>
      {renderSignupComponent()}
    </>
  )
}

export default Signup